<template>
    <div class="minimal-container">
        <div class="p-fluid">
            <div class="login-panel-content">
                <div class="grid">
                    <div class="col-12 logo-container">
                        <h2>{{ title }}</h2>
                    </div>
                    <div class="col-12">
                        <slot name="content"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MinimalLayout',
    props: {
        title: {
            type: String,
            default: 'Tytuł'
        }
    }
};
</script>

<style>
.minimal-container{
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
}

.minimal-card{
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    padding: 77px 55px 33px;
}

.minimal-container .login-panel-content {
    width: 336px;
}

.minimal-container .p-button {
    height: 48px;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
}
.minimal-container input.p-inputtext {
    height: 48px;
    padding-left: 16px;
}
.minimal-container .p-inputtext::placeholder {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #6C757D;
}

@media (max-width: 780px) {
    .login-panel-content {
        width: auto;
    }
}
</style>
